<template>
  <div :class="[this.$lang === 'ar' ? 'regular-ar right-dir' : 'regular-en left-dir', 'line-card']">
    <div :style="this.$lang === 'ar' ? { fontFamily: 'Mtn-arabic-regular' } : { fontFamily: 'Mtn-regular'}" v-if="data.length !== 0" v-html="data" class="html-content click-address"> </div>
    <div  v-if="!show" style="height: 300px">
      <Loader />
    </div>
    <Error v-if="fail"/>
  </div>
</template>
<script>
import Loader from '../LoaderBtn/Loader'
import Error from '../errorHandle/Error'
export default {
  components: { Error, Loader },
  props: {
    fetchedBefore: Boolean,
    data: String,
    load: Boolean,
    error: Boolean
  },
  created () {
    if (this.fetchedBefore) {
      this.show = true
      this.fail = false
      // this.content = this.data
    }
  },
  data () {
    return {
      content: '',
      show: false,
      fail: false
    }
  },
  watch: {
    data (val) {
      this.content = val
    },
    load (val) {
      if (val) {
        this.show = false
        this.fail = false
      } else {
        this.show = true
      }
    },
    error (val) {
      if (val) {
        this.fail = true
        this.show = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.line-card{
  width: 92%;
  min-height: 300px;
  border: 2px solid rgba(255,255,255,.7);
  background: linear-gradient(-45deg, rgba(242,242,242,.6), rgba(235,235,235,1));
  box-shadow: 10px 20px 30px rgba(0,0,0,.1);
  margin: 0 auto;
  border-radius: 45px;
  margin-bottom: 40px;
  padding: 50px 40px;
  text-align: initial;
}
.html-content{
  overflow-x: auto;
  overflow-y: hidden;
}
.html-content > * {
  font-family: inherit !important;
}
@media(max-width: 1000px) {
  .line-card {
    padding: 40px 30px;
  }
}
@media (max-width: 600px) {
  .line-card {
    padding: 30px 20px;
  }
}

</style>
